import {
  Button,
  Col,
  Row,
  Menu,
  Icon,
  Card,
  Layout,
  Dropdown,
  Avatar,
  Drawer,
  message,
  Alert
} from "ant-design-vue";

import "swiper/dist/css/swiper.css";

import VueAwesomeSwiper from "vue-awesome-swiper";

export default function(Vue) {
  console.log('message',message);
  Vue.prototype.$message=message;
  
  Vue.use(Button);
  Vue.use(Col);

  Vue.use(Row);
  Vue.use(Menu);

  Vue.use(Icon);
  Vue.use(Card);
  Vue.use(Layout);

  Vue.use(Dropdown);
  Vue.use(Avatar);
  Vue.use(Drawer);

  Vue.use(Alert);
  
  

  Vue.use(VueAwesomeSwiper /* { default global options } */);
}
